module.exports = __webpack_public_path__ + "static/media/h2s.f0411c15.jpg";